import { isNormalPositive } from '@bifrost-platform/bifront-sdk-react-wallet';
import { useCallback, useMemo, useRef } from 'react';
import CountUp from 'react-countup';

export default function CountingData({
  value,
  decimal = 0,
  prefix = '',
  suffix = '',
  isScrolled = false,
  delay = 0,
  duration = 3,
  ref,
  ...rest
}: {
  value: string;
  decimal: number;
  prefix?: string;
  suffix?: string;
  isScrolled?: boolean;
  delay?: number;
  duration?: number;
  ref?: React.Ref<HTMLDivElement>;
}) {
  // ref
  const tvlRef = useRef<HTMLDivElement>(null);
  const tvlCountRef = useRef<HTMLDivElement>(null);

  // memo
  const isNormalValue = useMemo(() => isNormalPositive(value, true), [value]);
  const end = useMemo(
    () => (isNormalValue ? Number(value) : 0),
    [isNormalValue, value]
  );
  const start = useMemo(() => end / 2, [end]);
  const decimalPlaces = useMemo(() => decimal, [decimal]);

  // callback
  const handleEnd = useCallback(() => {
    if (tvlRef.current) {
      tvlRef.current.remove();
    }
    if (tvlCountRef.current) {
      tvlCountRef.current.style.bottom = '0';
      tvlCountRef.current.style.position = 'relative';
    }
  }, []);

  return (
    <div style={{ position: 'relative' }}>
      <p ref={tvlRef} style={{ visibility: 'hidden' }} {...rest}>
        {prefix}
        {isNormalValue ? (
          <CountUp
            startOnMount
            onEnd={handleEnd}
            duration={0}
            end={end}
            start={start}
            decimalPlaces={decimalPlaces}
            delay={delay}
          >
            {({ countUpRef }) => <span ref={countUpRef} />}
          </CountUp>
        ) : (
          '-'
        )}
      </p>
      <p ref={tvlCountRef} style={{ position: 'absolute', top: 0 }} {...rest}>
        {prefix}
        {isNormalValue ? (
          <CountUp
            startOnMount
            onEnd={handleEnd}
            duration={duration}
            end={end}
            start={start}
            decimalPlaces={decimalPlaces}
            delay={delay}
          >
            {({ countUpRef }) => <span ref={countUpRef} />}
          </CountUp>
        ) : (
          '-'
        )}
      </p>
    </div>
  );
}
